define([
], function() {
    /**
     * 設定パラメータ
     */
    var Config = {};
    Config.ping = {
        interval: 30000,  // [ms]
        // 前回 ping 送信から interval + intervalBuffer 秒以上経過していればエラー
        intervalBuffer: 30000,  // [ms]
        // 指定ミリ秒数以内に ping 応答がなければエラー
        responseLimit: 10000  // [ms]
    };

    Config.event = {
        firstFetchLimit: 10,
        fetchLimit: 30
    };

    Config.milestone = {
        firstFetchLimit: 10,
        fetchLimit: 30
    };

    Config.recentChange = {
        firstFetchLimit: 5,
        fetchLimit: 10
    };

    return Config;
});



// WEBPACK FOOTER //
// ./balus/config.js